import * as _ from 'lodash';
import {Component, Inject, Input, OnDestroy, OnInit} from '@angular/core';
import {ReportsService} from '../../reports/reports.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatDialogTitle, MatDialogClose, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import {SelectedFilterValuesModel} from '../grid-filter/selected-filter-values.model';
import {PhoneNumbersUtils} from '../../core/utilities/phone-numbers-helpers';
import { FlexModule } from '@angular/flex-layout';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { FormsModule } from '@angular/forms';
import { CardOptionsComponent } from '../../core/visual/card/options-card.component';
import { CardComponent } from '../../core/visual/card/card.component';
import { MatPhoneNumberInputComponent } from '../../editors/mat-phone-number-input/mat-phone-number-input.component';
import { DurationInputComponent } from '../../editors/duration-input/duration-input.component';

export interface CallLogsCurrentFilterData {
  filter: Array<SelectedFilterValuesModel>;
}

@Component({
    selector: 'app-mat-call-logs-filter-dialog',
    templateUrl: './mat-call-logs-filter-dialog.component.html',
    styleUrls: ['./mat-call-logs-filter-dialog.component.scss'],
    standalone: true,
    imports: [
        FlexModule,
        MatDialogTitle,
        MatIconButton,
        MatDialogClose,
        MatIcon,
        CdkScrollable,
        MatDialogContent,
        FormsModule,
        CardOptionsComponent,
        CardComponent,
        MatPhoneNumberInputComponent,
        DurationInputComponent,
        MatDialogActions,
        MatButton,
    ],
})
export class MatCallLogsFilterDialogComponent implements OnInit, OnDestroy {

  @Input() title: string;
  @Input() actionTitle = 'Filter';
  @Input() text: string;

  public opened = false;

  onConfirm: Promise<void>;
  @Input() autoClose: boolean;

  filterByStatusOptions = [
    {value: 'Answered', text: 'Answered', id: _.uniqueId('id_')},
    {value: 'Mailbox', text: 'Mailbox', id: _.uniqueId('id_')},
    {value: 'Missed', text: 'Missed', id: _.uniqueId('id_')},
    {value: 'Hung Up', text: 'Hung Up', id: _.uniqueId('id_')},
    {value: 'Connected', text: 'Connected', id: _.uniqueId('id_')},
    {value: 'Not Connected', text: 'Not Connected', id: _.uniqueId('id_')},
    {value: 'Login', text: 'Login', id: _.uniqueId('id_')},
    {value: 'Logout', text: 'Logout', id: _.uniqueId('id_')},
  ];

  filterByTypeOptions = [
    {value: 'isIncoming', text: 'Incoming', id: _.uniqueId('id_')},
    {value: 'isOutgoing', text: 'Outgoing', id: _.uniqueId('id_')},
    {value: 'isLocal', text: 'Internal', id: _.uniqueId('id_')},
  ];

  filterExcludeOptions = [
    {value: 'isGroup', text: 'Agent Groups', id: _.uniqueId('id_')},
    {value: 'isHunt', text: 'Hunt Groups', id: _.uniqueId('id_')},
  ];

  checkedAttendantsOptions: any[] = [];
  checkedExtensionOptions: any[] = [];
  checkedGroupOptions: any[] = [];
  checkedHuntGroupOptions: any[] = [];
  checkedDepartmentOptions: any[] = [];
  checkedDomainOptions: any[] = [];

  checkedStatusOptions: any[] = [];
  checkedTypeOptions: any[] = [];
  checkedExcludeOptions: any[] = [];
  filterToNumber: string;
  filterFromNumber: string;

  filterDurationFrom: number;
  filterDurationTo: number;

  constructor(public reportsService: ReportsService,
              public dialogRef: MatDialogRef<MatCallLogsFilterDialogComponent>,
              public dialog: MatDialog,
              @Inject(MAT_DIALOG_DATA) public data: CallLogsCurrentFilterData
  ) {
  }

  ngOnInit() {
    if (this.data.filter) {
      for (const selectedFilter of this.data.filter) {
        if (selectedFilter.filterKey === 'statuses') {
          this.checkedStatusOptions = selectedFilter.values;
        } else if (selectedFilter.filterKey === 'types') {
          this.checkedTypeOptions = selectedFilter.values;
        } else if (selectedFilter.filterKey === 'exclude') {
          this.checkedExcludeOptions = selectedFilter.values;
        } else if (selectedFilter.filterKey === 'numberFrom') {
          this.filterFromNumber = selectedFilter.values[0];
        } else if (selectedFilter.filterKey === 'numberTo') {
          this.filterToNumber = selectedFilter.values[0];
        } else if (selectedFilter.filterKey === 'extensions') {
          this.checkedExtensionOptions = selectedFilter.values;
        } else if (selectedFilter.filterKey === 'departments') {
          this.checkedDepartmentOptions = selectedFilter.values;
        } else if (selectedFilter.filterKey === 'agentGroup') {
          this.checkedGroupOptions = selectedFilter.values;
        } else if (selectedFilter.filterKey === 'huntGroup') {
          this.checkedHuntGroupOptions = selectedFilter.values;
        } else if (selectedFilter.filterKey === 'attendants') {
          this.checkedAttendantsOptions = selectedFilter.values;
        } else if (selectedFilter.filterKey === 'durationFrom') {
          this.filterDurationFrom = Number(selectedFilter.values[0] || 0);
        } else if (selectedFilter.filterKey === 'durationTo') {
          this.filterDurationTo = Number(selectedFilter.values[0] || 0);
        } else if (selectedFilter.filterKey === 'domains') {
          this.checkedDomainOptions = selectedFilter.values;
        }
      }
    }
  }

  ngOnDestroy() {
  }

  getDomainNames(lookupList: any[], selectedDomains: string[]): string[] {
    const lookup = lookupList.filter(x => selectedDomains.includes(x.value));

    return lookup.map(x => x.text);
  }

  getAccountsNames(lookupList: any[], selectedAccounts: string[]): string[] {
    const lookup = lookupList.filter(x => selectedAccounts.includes(x.value));

    return lookup.map(x => x.text);
  }

  closeSendConfirmPopup(action: string) {
    if (action === 'close') {
      this.dialogRef.close();
    } else {
      const filter: SelectedFilterValuesModel[] = [];

      if (this.checkedStatusOptions.length > 0) {
        filter.push({
          filterKey: 'statuses',
          multiValue: true,
          title: 'Call Status',
          values: this.checkedStatusOptions,
          displayValues: this.checkedStatusOptions
        });
      }

      if (this.checkedTypeOptions.length > 0) {
        filter.push({
          filterKey: 'types',
          multiValue: true,
          title: 'Call Type',
          values: this.checkedTypeOptions,
          displayValues: this.checkedTypeOptions.map(x => {
            return x === 'isIncoming' ? 'Incoming' : x === 'isOutgoing' ? 'Outgoing' : 'Internal';
          })
        });
      }

      if (this.checkedExcludeOptions.length > 0) {
        filter.push({
          filterKey: 'exclude',
          multiValue: true,
          title: 'Exclude',
          values: this.checkedExcludeOptions,
          displayValues: this.checkedExcludeOptions.map(x => {
            return x === 'isGroup' ? 'Agent Groups' : 'Hunt Groups';
          })
        });
      }

      if (this.filterToNumber) {
        filter.push({
          filterKey: 'numberTo',
          multiValue: false,
          title: 'Number To',
          values: [this.filterToNumber],
          displayValues: [PhoneNumbersUtils.format(this.filterToNumber)]
        });
      }

      if (!!this.filterFromNumber) {
        filter.push({
          filterKey: 'numberFrom',
          multiValue: false,
          title: 'Number From',
          values: [this.filterFromNumber],
          displayValues: [PhoneNumbersUtils.format(this.filterFromNumber)]
        });
      }

      if (this.filterDurationFrom) {
        filter.push({
          filterKey: 'durationFrom',
          multiValue: false,
          title: 'Duration From',
          values: [`${this.filterDurationFrom}`],
          displayValues: [`${this.filterDurationFrom} sec`]
        });
      }

      if (!!this.filterDurationTo) {
        filter.push({
          filterKey: 'durationTo',
          multiValue: false,
          title: 'Duration To',
          values: [`${this.filterDurationTo}`],
          displayValues: [`${this.filterDurationTo} sec`]
        });
      }

      if (this.checkedExtensionOptions.length > 0) {
        filter.push({
          filterKey: 'extensions',
          multiValue: true,
          title: 'User',
          values: this.checkedExtensionOptions,
          displayValues: this.getAccountsNames(this.reportsService.extensionsLookup, this.checkedExtensionOptions),
        });
      }

      if (this.checkedDepartmentOptions.length > 0) {
        filter.push({
          filterKey: 'departments',
          multiValue: true,
          title: 'Departments',
          values: this.checkedDepartmentOptions,
          displayValues: this.getAccountsNames(this.reportsService.departmentsLookup, this.checkedDepartmentOptions),
        });
      }

      if (this.checkedGroupOptions.length > 0) {
        filter.push({
          filterKey: 'agentGroup',
          multiValue: true,
          title: 'Agent Group',
          values: this.checkedGroupOptions,
          displayValues: this.getAccountsNames(this.reportsService.groupsLookup, this.checkedGroupOptions),
        });
      }

      if (this.checkedHuntGroupOptions.length > 0) {
        filter.push({
          filterKey: 'huntGroup',
          multiValue: true,
          title: 'Hunt Group',
          values: this.checkedHuntGroupOptions,
          displayValues: this.getAccountsNames(this.reportsService.huntGroupsLookup, this.checkedHuntGroupOptions),
        });
      }

      if (this.checkedAttendantsOptions.length > 0) {
        filter.push({
          filterKey: 'attendants',
          multiValue: true,
          title: 'Attendant',
          values: this.checkedAttendantsOptions,
          displayValues: this.getAccountsNames(this.reportsService.attendantsLookup, this.checkedAttendantsOptions),
        });
      }

      if (this.checkedDomainOptions.length > 0) {
        console.log(this.checkedDomainOptions);
        filter.push({
          filterKey: 'domains',
          multiValue: true,
          title: 'Companies',
          values: this.checkedDomainOptions,
          displayValues: this.getDomainNames(this.reportsService.domainsLookup, this.checkedDomainOptions),
        });
      }

      this.dialogRef.close(filter);
    }
  }
}
